module.exports = __webpack_public_path__ + "11d415a50f7677ecc0c99dee2153735d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ads/microsoft_sample_ad.jpg
// module id = 1610
// module chunks = 0